import { Stack, Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TopNavigationInvestor } from '../navigation-top/TopNavigationInvestor'
import { OpportunityCard } from './OpportunityCard'
import { IInvestmentProduct } from '~/@api/generated-api-types/global.types'
import useOpportunityStore from '../useOpportunityStore/useOpportunityStore'
import { useAlert } from '~/@ui/alert/useAlert'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'

export const OpportunitiesPage: FC = () => {
  const navigate = useNavigate()
  const { clearOpportunity } = useOpportunityStore()
  const { showAlert } = useAlert()
  const { user } = useCurrentUserData()

  const [opportunities, setOpportunities] = useState<
    IInvestmentProduct[] | null
  >(null)

  const getOpportunities = async () => {
    try {
      const { data: response } =
        await getApi().investmentProductsAppApiControllerGetInvestmentProducts()

      if ('success' in response) {
        setOpportunities(response.investmentProducts)
        return
      }

      throw new Error('Nastala chyba pri načítavaní investičných príležitostí.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  const navigateToOpportunityPage = (productId: string) => {
    navigate(`/investor/opportunities/${productId}`)
  }

  useEffect(() => {
    clearOpportunity()
    getOpportunities()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack className="w-full">
      <TopNavigationInvestor user={user} />

      <Stack className="relative w-full max-w-[768px] self-center gap-4 p-6 pb-28">
        <Stack className="gap-3">
          <Typography className="text-xl font-bold text-zBlack200">
            Nová investícia
          </Typography>
          <Typography className="text-3d font-medium text-zGrey400">
            S ktorou situáciou sa najviac stotožňujete?
          </Typography>
        </Stack>

        <Stack className="gap-3d">
          {opportunities &&
            opportunities.map((opp) => (
              <OpportunityCard
                key={opp.id}
                headerText={opp.name}
                bodyText={opp.description || ''}
                slug={opp.slug}
                onClick={() => navigateToOpportunityPage(opp.slug)}
              />
            ))}
        </Stack>
      </Stack>
    </Stack>
  )
}
